import StdForm from '@shared/components/forms/auto-form/std-form/std-form.vue';
import { Component, Prop } from 'vue-property-decorator';
import EntityTableProvider from '@shared/components/tables/entity-table-provider/entity-table-provider.vue';
import EntityTable from '@shared/components/tables/entity-table/entity-table.vue';
import BpcPageTitle from '@shared/layouts/components/page-title/page-title.vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import EntityDeleteModalProvider from '@shared/components/modals/entity-delete-modal-provider/entity-delete-modal-provider.vue';
import ConfirmationModal from '@shared/components/modals/confirmation-modal/confirmation-modal.vue';
import { ValidationObserver } from 'vee-validate';
import { mixins } from 'vue-class-component';
import AbstractTable from '@shared/components/tables/abstract-table/abstract-table';
import StdFilter from '@shared/components/filters/std-filter/std-filter.vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faSync } from '@fortawesome/free-solid-svg-icons';
import { MenuEntry } from '@cms/interfaces/menu-entry';
import DrawerModal from '@shared/components/modals/drawer-modal/drawer-modal.vue';
import TranslatableModal from '@core/components/modals/translatable-modal.vue';

library.add(faSync);

@Component({
  name: 'bpc-menu-entry-table',
  components: {
    'bpc-entity-table-provider': EntityTableProvider,
    'bpc-entity-table': EntityTable,
    'bpc-page-title': BpcPageTitle,
    'font-awesome-icon': FontAwesomeIcon,
    'bpc-entity-delete-modal-provider': EntityDeleteModalProvider,
    'bpc-confirmation-modal': ConfirmationModal,
    'bpc-std-form': StdForm,
    'bpc-std-filter': StdFilter,
    ValidationObserver,
    'bpc-drawer-modal': DrawerModal,
    'bpc-translatable-modal': TranslatableModal,
  },
})
export default class MenuEntryTable extends mixins(AbstractTable) {
  declare $refs: AbstractTable['$refs'] & {
    translatableModal: InstanceType<typeof TranslatableModal> & {
      onOpenModal(): void;
      onCloseModal(): void;
    };
  };
  @Prop(String) readonly displayConfigName: string;
  @Prop(String) readonly title: string;
  @Prop(String) readonly subtitle: string;

  public entity: MenuEntry = null;
  public entityName = 'menu-entry';
  public pluralEntityName = 'menu-entries';
  public postDetailsModalTitle = '';
  public permissionEntityNameToUse = 'menu_entries';

  public flagsToCheckBeforeLoadEntities: Array<any> = [
    'configLoaded',
    'paginationLoaded',
    'orderLoaded',
    'filtersLoaded',
    'urlParametersLoaded',
  ];

  get totalAvailableLanguages() {
    return this.$store.getters['centerSettings/totalAvailableLanguages'];
  }

  setEntityAttributesAfterSave() {
    const newEntity = {} as MenuEntry;
    Object.keys(this.entity).forEach(key => {
      this.$set(newEntity, key, null);
    });

    this.$set(newEntity, 'type', 'post');
    this.$set(newEntity, 'published', 1);
    this.$set(this.$refs.stdForm, 'formModel', newEntity);

    this.showForm = true;
    this.showDrawerSection = true;
  }

  openTranslatableModal(): void {
    this.$refs.translatableModal.onOpenModal();
  }

  /* Lifecycle hooks */

  // created() {}
  // mounted() {}
  // updated() {}
  // destroyed() {}
}
